import FoodLog from './FoodLog';

export default FoodLog;
